import { cn } from "@heroui/react"
import { Pending } from "./Pending"

export default ({ className = "", children }: any) => {
  return <div className="fixed left-0 top-0 w-[100vw] h-[100vh] z-[100]">
    <div className={cn("grid place-content-center w-full h-full absolute z-[1] left-0 top-0 bg-surface/20 backdrop-blur-md", className)}>
      {children}
      <Pending />
    </div>
  </div>
}